import { useState } from "react";
import { useAuth } from "../context/AuthContext";

// Test account credentials
const TEST_ACCOUNTS = {
  DEV: {
    email: "dev@masterymethod.com",
    password: "devmaster2024",
    type: "developer",
  },
  STANDARD: {
    email: "standard@test.com",
    password: "standardpass",
    type: "standard",
  },
  PRO: {
    email: "pro@test.com",
    password: "propass1",
    type: "pro",
  },
};

const Login = ({ onBackToWelcome, onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const userCredential = await login(email, password);

      // Check account type and set appropriate flags
      if (email === TEST_ACCOUNTS.DEV.email) {
        localStorage.setItem("devMode", "true");
        localStorage.setItem("isDeveloper", "true");
        console.log("Developer mode activated");
      } else if (email === TEST_ACCOUNTS.STANDARD.email) {
        localStorage.setItem("accountType", "standard");
        localStorage.setItem("isTestAccount", "true");
        console.log("Standard test account activated");
      } else if (email === TEST_ACCOUNTS.PRO.email) {
        localStorage.setItem("accountType", "pro");
        localStorage.setItem("isTestAccount", "true");
        console.log("Pro test account activated");
      } else {
        // Clear test flags for regular users
        localStorage.removeItem("devMode");
        localStorage.removeItem("isDeveloper");
        localStorage.removeItem("isTestAccount");
        localStorage.removeItem("accountType");
      }

      onLoginSuccess && onLoginSuccess();
    } catch (err) {
      setError(
        err.code === "auth/user-not-found" || err.code === "auth/wrong-password"
          ? "Invalid email or password"
          : "An error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Quick login functions for development
  const handleTestLogin = async (accountType) => {
    if (process.env.NODE_ENV !== "development") return;

    const account = TEST_ACCOUNTS[accountType];
    setEmail(account.email);
    setPassword(account.password);

    const loginForm = document.querySelector("form");
    if (loginForm) {
      loginForm.requestSubmit();
    }
  };

  // Test account button style
  const testButtonStyle = (color) => ({
    marginTop: "0.5rem",
    backgroundColor: color,
    color: "white",
    border: "none",
    padding: "0.75rem 1rem",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "0.875rem",
    width: "100%",
  });

  return (
    <div className="login-container">
      <button className="back-button" onClick={onBackToWelcome}>
        ←
      </button>
      <h1>Mastery Method</h1>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleLogin}>
        <div className="input-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            disabled={isLoading}
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
            disabled={isLoading}
          />
        </div>
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Signing In..." : "Sign In"}
        </button>
      </form>

      {process.env.NODE_ENV === "development" && (
        <div className="test-accounts-section">
          <button
            onClick={() => handleTestLogin("DEV")}
            style={testButtonStyle("#2563eb")} // Blue for dev
          >
            Developer Login
          </button>
          <button
            onClick={() => handleTestLogin("STANDARD")}
            style={testButtonStyle("#10b981")} // Green for standard
          >
            Standard Test Account
          </button>
          <button
            onClick={() => handleTestLogin("PRO")}
            style={testButtonStyle("#8b5cf6")} // Purple for pro
          >
            Pro Test Account
          </button>
        </div>
      )}

      <p className="helper-text">
        Forgot your password?{" "}
        <a href="#" className="text-link">
          Reset it here
        </a>
      </p>
    </div>
  );
};

export default Login;
